class VideoLightbox extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-video-trigger]');
    this.dialog = this.querySelector('[data-video-dialog]');
    this.closeButton = this.querySelector('[data-video-close]');
    this.player = this.querySelector('[data-video-player]');

    this.trigger?.addEventListener('click', this.open.bind(this));
    this.closeButton?.addEventListener('click', this.close.bind(this));
    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
    this.dialog?.addEventListener('close', this.stopPlayback.bind(this));
  }

  open() {
    if (!this.dialog || this.dialog.open) return;
    this.dialog.showModal();
  }

  close() {
    if (!this.dialog?.open) return;

    this.dialog.classList.add('video-lightbox--closing');
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      this.dialog.classList.remove('video-lightbox--closing');
      this.dialog.close();
    };
    this.dialog.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, 400);
  }

  stopPlayback() {
    if (!this.player) return;
    this.player.querySelectorAll('video').forEach((video) => video.pause());
    this.player.querySelectorAll('iframe').forEach((iframe) => {
      iframe.src = iframe.src;
    });
  }
}

customElements.define('video-lightbox', VideoLightbox);
